import {Async, Loaded, Loading } from 'Core/models/Async';

export class UnassignedCancerPlanTypes {
    
    public readonly key = 'UnassignedCancerPlanTypes';
  }

export type CancerPlanTypes = Async<string[]> | UnassignedCancerPlanTypes;

type MatchCancerPlanOptions<TReturn> = {
    Loading: () => TReturn;
    Loaded: (planTypes: string[]) => TReturn;
    Error: () => TReturn;
    Unassigned: (planTypes: []) => TReturn;
  };

export const isLoading = (planTypes: CancerPlanTypes): planTypes is Loading<string[]> =>
    planTypes.key === 'Loading';

export const isLoaded = (planTypes: CancerPlanTypes): planTypes is Loaded<string[]> => planTypes.key === 'Loaded';

export const matchCancerPlanTypes = <TReturn>(options: MatchCancerPlanOptions<TReturn>) => (
    products: CancerPlanTypes
  ) => {
  
    switch (products.key) {
      case 'UnassignedCancerPlanTypes':
        return options.Unassigned([]);
      case 'Loaded':
        return options.Loaded(products.Data);
      case 'Loading':
        return options.Loading();
      case 'Conflict':
        return options.Error();
      case 'ServerError':
        return options.Error();
      case 'Unauthorized':
        return options.Error();
    }
  };
  